// ==== action types ====

export const VALIDATE_INSURED_INFORMATION = 'VALIDATE_INSURED_INFORMATION'

export const SELECT_GENDER = 'SELECT_GENDER'

export const SELECT_PAYER_GENDER = 'SELECT_PAYER_GENDER'

export const SELECT_PAYER_RELATION = 'SELECT_PAYER_RELATION'

export const SET_OCCUPATION_FACTOR = 'SET_OCCUPATION_FACTOR'

export const EDIT_BIRTHDATE = 'EDIT_BIRTHDATE'

export const UPDATE_BIRTHDATE = 'UPDATE_BIRTHDATE'

export const PATCH_BIRTHDATE = 'PATCH_BIRTHDATE'

export const UPDATE_PAYER_BIRTHDATE = 'UPDATE_PAYER_BIRTHDATE'

export const PATCH_PAYER_BIRTHDATE = 'PATCH_PAYER_BIRTHDATE'

export const EDIT_PAYER_BIRTHDATE = 'EDIT_PAYER_BIRTHDATE'

export const SELECT_OCCUPATION = 'SELECT_OCCUPATION'

export const SELECT_NATURE_OF_DUTY = 'SELECT_NATURE_OF_DUTY'

export const RESET_OCCUPATION = 'RESET_OCCUPATION'

export const SELECT_PAYER_OCCUPATION = 'SELECT_PAYER_OCCUPATION'

export const SELECT_PAYER_NATURE_OF_DUTY = 'SELECT_PAYER_NATURE_OF_DUTY'

export const SELECT_OTHER_OCCUPATION = 'SELECT_OTHER_OCCUPATION'

export const SELECT_PAYER_OTHER_OCCUPATION = 'SELECT_PAYER_OTHER_OCCUPATION'

export const SELECT_OTHER_NATURE_OF_DUTY = 'SELECT_OTHER_NATURE_OF_DUTY'

export const SELECT_PAYER_OTHER_NATURE_OF_DUTY = 'SELECT_PAYER_OTHER_NATURE_OF_DUTY'

export const TOGGLE_OTHER_OCCUPATION = 'TOGGLE_OTHER_OCCUPATION'

export const TOGGLE_PAYER_OTHER_OCCUPATION = 'TOGGLE_PAYER_OTHER_OCCUPATION'

export const UPDATE_OTHER_OCCUPATION_ERRORS = 'UPDATE_OTHER_OCCUPATION_ERRORS'

export const UPDATE_PAYER_OTHER_OCCUPATION_ERRORS = 'UPDATE_PAYER_OTHER_OCCUPATION_ERRORS'

export const UPDATE_PAYER_NEEDED = 'UPDATE_PAYER_NEEDED'

export const UPDATE_OCCUPATION_ERRORS = 'UPDATE_OCCUPATION_ERRORS'

export const UPDATE_PAYER_OCCUPATION_ERRORS = 'UPDATE_PAYER_OCCUPATION_ERRORS'

export const SELECT_REASON = 'SELECT_REASON'

export const EDIT_TITLE_NAME = 'TITLE/EDIT_NAME'

// ==== action creators ====
export const validateInsuredInformation = () => ({
  type: VALIDATE_INSURED_INFORMATION,
})

export const selectGender = (gender) => ({
  type: SELECT_GENDER,
  payload: gender,
})

export const selectReason = (reason) => ({
  type: SELECT_REASON,
  payload: reason,
})

export const selectPayerGender = (gender) => ({
  type: SELECT_PAYER_GENDER,
  payload: gender,
})

export const selectPayerRelation = (relation) => ({
  type: SELECT_PAYER_RELATION,
  payload: relation,
})

export const CLEAR_PAYER_INFORMATION = 'CLEAR_PAYER_INFORMATION'
export const clearPayerInformation = () => ({
  type: CLEAR_PAYER_INFORMATION,
})

export const CLEAR_PAYER_NEEDED = 'CLEAR_PAYER_NEEDED'
export const clearPayerNeeded = () => ({
  type: CLEAR_PAYER_NEEDED,
})

export const editBirthdate = (birthdate, forceUpdate = false) => ({
  type: EDIT_BIRTHDATE,
  birthdate: birthdate,
  forceUpdate: forceUpdate,
})

export const updateBirthdate = (birthdate, errors, age) => ({
  type: UPDATE_BIRTHDATE,
  birthdate,
  errors,
  age,
})

export const patchBirthdate = (birthdate, errors, age) => ({
  type: PATCH_BIRTHDATE,
  birthdate,
  errors,
  age,
})

export const editPayerBirthdate = (birthdate) => {
  return {
    type: EDIT_PAYER_BIRTHDATE,
    birthdate: birthdate,
  }
}

export const updatePayerBirthdate = (birthdate, errors, age) => ({
  type: UPDATE_PAYER_BIRTHDATE,
  birthdate,
  errors,
  age,
})

export const patchPayerBirthdate = (birthdate, errors, age) => ({
  type: PATCH_PAYER_BIRTHDATE,
  birthdate,
  errors,
  age,
})

export const selectOccupation = (selectedOccupation) => ({
  type: SELECT_OCCUPATION,
  payload: selectedOccupation,
})

export const selectNatureOfDuty = (natureOfDuty) => ({
  type: SELECT_NATURE_OF_DUTY,
  payload: natureOfDuty,
})

export const resetOccupation = () => ({
  type: RESET_OCCUPATION,
})

export const selectPayerOccupation = (selectedOccupation) => ({
  type: SELECT_PAYER_OCCUPATION,
  payload: selectedOccupation,
})

export const selectPayerNatureOfDuty = (natureOfDuty) => ({
  type: SELECT_PAYER_NATURE_OF_DUTY,
  payload: natureOfDuty,
})

export const selectOtherOccupation = (selectedOtherOccupation) => ({
  type: SELECT_OTHER_OCCUPATION,
  payload: selectedOtherOccupation,
})

export const selectPayerOtherOccupation = (selectedPayerOtherOccupation) => ({
  type: SELECT_PAYER_OTHER_OCCUPATION,
  payload: selectedPayerOtherOccupation,
})

export const selectOtherNatureOfDuty = (otherNatureOfDuty) => ({
  type: SELECT_OTHER_NATURE_OF_DUTY,
  payload: otherNatureOfDuty,
})

export const selectPayerOtherNatureOfDuty = (payerOtherNatureOfDuty) => ({
  type: SELECT_PAYER_OTHER_NATURE_OF_DUTY,
  payload: payerOtherNatureOfDuty,
})

export const toggleOtherOccupation = () => ({
  type: TOGGLE_OTHER_OCCUPATION,
})

export const togglePayerOtherOccupation = () => ({
  type: TOGGLE_PAYER_OTHER_OCCUPATION,
})

export const updateOtherOccupationErrors = (errors) => ({
  type: UPDATE_OTHER_OCCUPATION_ERRORS,
  payload: errors,
})

export const updatePayerOtherOccupationErrors = (errors) => ({
  type: UPDATE_PAYER_OTHER_OCCUPATION_ERRORS,
  payload: errors,
})

export const updatePayerNeeded = (payerNeeded) => ({
  type: UPDATE_PAYER_NEEDED,
  payload: payerNeeded,
})

export const setOccupationFactor = (occupationFactor) => ({
  type: SET_OCCUPATION_FACTOR,
  payload: occupationFactor,
})

export const updateOccupationErrors = (errors) => ({
  type: UPDATE_OCCUPATION_ERRORS,
  payload: errors,
})

export const updatePayerOccupationErrors = (errors) => ({
  type: UPDATE_PAYER_OCCUPATION_ERRORS,
  payload: errors,
})
